import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RestudyEconomicManagerDecision, FormMode, Languages, ServiceStatus ,AttachmentType} from 'src/app/shared/models/enums.model';
import { ReleaseRestudyRequestDTO, ReleaseRestudyAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/shared/services/app.config';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
@Component({
  selector: 'app-Restudy-economic',
  templateUrl: './Restudy-economic.component.html'
})
export class RestudyEconomicComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  restudyRequestObj: ReleaseRestudyRequestDTO = new ReleaseRestudyRequestDTO();
  refundAdminObj: ReleaseRestudyAdminDTO = new ReleaseRestudyAdminDTO();
  attachments: Attachment[] = [];
  decision = RestudyEconomicManagerDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  moreInfoMessage: string = "";
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  showModifications:boolean = false;
 
  user: User = new User();
  restudyManagerForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  ListOfAdmins: [] = [];
  adminsDropdownSettings = {};
  selectedEmails: [] = [];
  documentsProgres: number;
  uploadFolder = AppConfig.settings.apiServer.ReleaseUploadsFolder;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private fileService: fileService,
    private translate: TranslateService,
    private alertService: AlertService,
    private longhaulserv: LongHaulService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
    this.adminsDropdownSettings = {
      singleSelection: false,
      idField: 'Email',
      textField: 'Username',
      selectAllText: 'Select All',
      unSelectAllText:  'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: true
    };
  }
  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.restudyManagerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
      AttachmentURL: [''],

    });
    if (decision == RestudyEconomicManagerDecision.Approve) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Approve: ['', [Validators.required]],
        AttachmentURL: [''],

      });
    }
    else if (decision == RestudyEconomicManagerDecision.Modify) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Modify: ['', [Validators.required]],
        Approve: ['', [Validators.required]],
        AttachmentURL: [''],

      });

    }
    else if (decision == RestudyEconomicManagerDecision.Cancel) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Cancel: ['', [Validators.required]],
        AttachmentURL: [''],

      });

    }else if (decision == RestudyEconomicManagerDecision.MoreInformation) {
      this.restudyManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
        AttachmentURL: [''],

      });
    }
  }
  get form() {
    return this.restudyManagerForm.controls;
  }

  changeDecision(value) {
    this.buildForm(value);
    this.restudyManagerForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
    /*if(this.decisionValue == RestudyEconomicManagerDecision.Approve){
      this.getNextStepUsers();
    }*/
  }

  getRequest() {

    this.longhaulserv.GetRestudyRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.restudyRequestObj = this.responseObj.Data;
          this.requestStatus = this.restudyRequestObj.BaseRequest.StatusId;
          this.isLoaded = true;
          if (history.state.data && history.state.data.isCompleted) {
            this.decisionValue = this.restudyRequestObj.EunitRegistersDecision;
            if(this.restudyRequestObj.EunitApproveDecision == 2){
              this.showModifications = true,
              this.moreInfoMessage =  this.restudyRequestObj.EunitApproveNotes;
            }

            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Modify) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Modify: this.restudyRequestObj.EunitRegisterNotes
              });
            }
           
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Approve) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Approve: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Cancel) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Cancel: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.MoreInformation) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue,
              });
            }
            this.formMode = FormMode.Readonly;
            this.restudyManagerForm.disable();
          }
          else if(this.requestStatus == ServiceStatus.Restudy_PendingEconomicApproval){
            this.formMode = FormMode.Add;
            if(this.restudyRequestObj.EunitApproveDecision == 2){
              this.showModifications = true,
              this.moreInfoMessage =  this.restudyRequestObj.EunitApproveNotes;
            }
            this.restudyManagerForm.enable();
          }
          else{
            this.formMode = FormMode.Readonly;
            this.restudyManagerForm.disable();
            this.decisionValue = this.restudyRequestObj.EunitRegistersDecision;
            if (this.restudyRequestObj.EunitRegistersDecision == RestudyEconomicManagerDecision.Modify) {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue ,
                Modify: this.restudyRequestObj.EunitRegisterNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.restudyManagerForm.patchValue({
                Decision: this.decisionValue,
              });
            }

          }
        }
      }
    )
  }

  getNextStepUsers() {
    this.longhaulserv.GetNextStepUsers('SCAServices_RestudyEconomicApprove').subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          this.ListOfAdmins = resObj.Data;
        }
      }
    )
  }

  nextUsersListChanged() {
    if (this.form.Admins && this.form.Admins.value != null) {
      this.selectedEmails = this.form.Admins.value.map(function (e) {
        return e.Email;
      });
    }
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.restudyManagerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

    // this.restudyRequestObj = this.restudyManagerForm.value;
    this.refundAdminObj.AdminEmail = this.user.UserName;
    this.refundAdminObj.Id = this.baseRequestId;
    this.refundAdminObj.Attachments= this.attachments;
    this.refundAdminObj.EunitRegistersDecision = this.decisionValue;
    if (this.decisionValue == RestudyEconomicManagerDecision.Approve) {
      this.refundAdminObj.EunitRegisterNotes = this.restudyManagerForm.controls.Approve.value;
    } else if(this.decisionValue == RestudyEconomicManagerDecision.Modify){
      this.refundAdminObj.EunitRegisterNotes = this.restudyManagerForm.controls.Modify.value;
      this.refundAdminObj.EunitModifyRebateNote = this.restudyManagerForm.controls.Approve.value;
    }
    else if(this.decisionValue == RestudyEconomicManagerDecision.MoreInformation){
      this.refundAdminObj.EunitRegisterNotes = this.restudyManagerForm.controls.MoreInformation.value;
    }
    else if(this.decisionValue == RestudyEconomicManagerDecision.Cancel){
      this.refundAdminObj.EunitRegisterNotes = this.restudyManagerForm.controls.Cancel.value;
    }
    else{
      this.refundAdminObj.EunitRegisterNotes = this.restudyManagerForm.controls.Cancel.value;
    }

    this.longhaulserv.SubmitEconomicDecision(this.refundAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.restudyManagerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
  public onFileSelected(event, progressVariableName) {
    this[progressVariableName] = 0;
    let percentDone = 0;
    this.alertService.clear();
    var formControlName = event.target.attributes['formControlName'].value;
    if (!this.fileService.IsFileExtentionValid(event)) {
      this.restudyManagerForm.get(formControlName).setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      this.restudyManagerForm.controls['agentCertificate'].get(formControlName).setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });

    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      let docName = file.name.split('.').slice(0, -1).join('.')
      formData.append('DocumentName', docName);

      formData.append('FolderName', this.uploadFolder); //New Line
      this.fileService.fileUploader(formData).subscribe(
        event => {

          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            percentDone = Math.round(100 * event.loaded / event.total)

            // console.log(`File is ${percentDone}% uploaded.`);

            this[progressVariableName] = percentDone;

            this.restudyManagerForm.get(formControlName).setErrors({ notCompleted: true });
          }
          else if (event instanceof HttpResponse) {
            this.restudyManagerForm.get(formControlName).setErrors(null);
            const jsonResponse = event.body.Data;
            const Url = jsonResponse.Url;
            const attachment = new Attachment();
            attachment.URL = Url;
            attachment.DocumentName = docName;
            attachment.AttachmentTypeId = AttachmentType.ReleaseFormEco;
            attachment.BaseRequestId = this.baseRequestId;
            this.attachments = this.attachments.filter(h => h.DocumentName != docName);
            this.attachments.push(attachment);

            this.restudyManagerForm.get(formControlName).setErrors(null);
            this.restudyManagerForm.get(formControlName).updateValueAndValidity();
          }
        }

      );

    }
  }

}
